var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archive-minus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_archive-minus",
    "data-name": "vuesax/outline/archive-minus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-minus-2",
    "data-name": "archive-minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.37,21.5a2.31,2.31,0,0,1-1.16-.3A2.753,2.753,0,0,1,0,18.71V4.61A4.615,4.615,0,0,1,4.61,0h9.65A4.615,4.615,0,0,1,18.87,4.61V18.7A2.751,2.751,0,0,1,17.66,21.19a2.27,2.27,0,0,1-1.162.3,3.356,3.356,0,0,1-1.608-.453l-4.88-2.71a1.436,1.436,0,0,0-1.15,0L3.98,21.04A3.373,3.373,0,0,1,2.37,21.5Zm7.07-4.787a2.728,2.728,0,0,1,1.3.307l4.881,2.71a1.83,1.83,0,0,0,.874.272.78.78,0,0,0,.406-.1,1.353,1.353,0,0,0,.47-1.2V4.61A3.113,3.113,0,0,0,14.26,1.5H4.62A3.113,3.113,0,0,0,1.51,4.61V18.7a1.33,1.33,0,0,0,.47,1.2.777.777,0,0,0,.406.1,1.83,1.83,0,0,0,.874-.272l4.88-2.71A2.732,2.732,0,0,1,9.44,16.713Z",
    transform: "translate(2.56 1.25)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M24,0V24H0V0Z",
    fill: "#bf8d46",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmarkIcon.1b4f71fc28f3eda0321f7b830c8756b0.svg";
export { ForwardRef as ReactComponent };